/** Raw input belongs to the editing draft; only parsed values belong in requests. */
export class FormInputDraft {
	constructor(
		readonly kind: "number" | "primitive-array" | "json-array" | "json-object",
		readonly text: string,
		readonly value: unknown,
		readonly error: string | null = null,
	) {}

	toJSON(): unknown {
		if (this.error) throw new Error(this.error);
		return this.value;
	}
}

export function hasInvalidFormInput(value: unknown): boolean {
	if (value instanceof FormInputDraft) return value.error !== null;
	if (Array.isArray(value)) return value.some(hasInvalidFormInput);
	return value !== null && typeof value === "object"
		? Object.values(value).some(hasInvalidFormInput)
		: false;
}

export function serializeFormInputs(value: unknown): unknown {
	if (value instanceof FormInputDraft)
		return serializeFormInputs(value.toJSON());
	if (Array.isArray(value)) return value.map(serializeFormInputs);
	if (value !== null && typeof value === "object") {
		return Object.fromEntries(
			Object.entries(value).map(([key, item]) => [
				key,
				serializeFormInputs(item),
			]),
		);
	}
	return value;
}

export function inputDraftSnapshot(value: unknown): unknown {
	if (value instanceof FormInputDraft) {
		return {
			kind: value.kind,
			text: value.text,
			value: inputDraftSnapshot(value.value),
			error: value.error,
		};
	}
	if (Array.isArray(value)) return value.map(inputDraftSnapshot);
	if (value !== null && typeof value === "object") {
		return Object.fromEntries(
			Object.keys(value)
				.sort()
				.map((key) => [
					key,
					inputDraftSnapshot((value as Record<string, unknown>)[key]),
				]),
		);
	}
	return value;
}
